import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'
import 'lib-flexible/flexible.js'
import { Toast, Notify, Dialog } from 'vant'

// import Vconsole from 'vconsole';
// var vConsole = new Vconsole();
// Vue.use(vConsole)

Vue.config.productionTip = false;
Vue.use(Toast).use(Notify).use(Dialog)
Vue.use(VueCookie)

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')